<template>
    <div class="bt-container">
        <div class="form-box">
            <div class="form-item">
                <img src="@/assets/img/baitiao/name.png" alt="">
                <input v-model="form.real_name" type="text" placeholder="请输入真实姓名">
            </div>
            <div class="form-item">
                <img src="@/assets/img/baitiao/phone.png" alt="">
                <input v-model="form.telephone" type="text" placeholder="请输入手机号">
            </div>
            <div class="form-item">
                <img src="@/assets/img/baitiao/idcard.png" alt="">
                <input v-model="form.car_number" type="text" placeholder="请输入身份证">
            </div>

            <div class="submit" @click="submit">
                确认提交
            </div>
        </div>

        <div class="bottom-logo">
             <img src="@/assets/img/baitiao/logo.png" alt="">
             <div>云鸟白条</div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data () {
        return {
            form: {
                user_id: '',
                telephone: '',
                car_number: '',
                real_name: ''
            }
        }
    },
    created () {
        document.title = "云鸟白条";
        this.form.user_id = this.$route.params.id;  
        window.console.log(this.form)
    },
    methods: {
        submit(){
            let self = this,
            valid = true;

            Object.keys(this.form).forEach(res => {
                if (!self.form[res]) {
                valid = false;
                }
            });

            if (!valid) {
                alert("请完善信息");
                return;
            }
            
            axios.post("/api/whiteBar", this.form).then(res => {
                if (res.data.code == 200) {
                alert("提交成功");
                }
            });
        }
    }
}
</script>

<style>
body{
    padding: 0;
}
/* .header, .footer{
    display: none !important;
} */
</style>

<style lang="scss" scoped>
.bt-container{
    width: 100%;
    height: 100vh;
    display: flex;
    // justify-content: center;
    align-items: center;
    background: #3E4966; 
    flex-direction: column;
    .form-box{
        margin-top: 0.6rem;
        border-radius:6px;
        width: 6.7rem;
        height: 8.28rem;
        background: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        .form-item{
            width: 5.3rem;
            height: 1.06rem;
            border-bottom: 1px solid #E8EBEC;
            display: flex;
            align-items: flex-end;
            padding-bottom: 0.16rem;
            // justify-content: center;
            &:first-of-type{
                margin-top: 1rem;
            }
            img{
                width: 0.44rem;
                height: 0.56rem;
            }
            input{
                border: none;
                padding: 0;
                height: 0.56rem;
                margin-left: .1rem;
                font-size: 0.28rem;
                outline: none;
            }
        }
         .submit{
            width:5.3rem;
            height:0.88rem;
            background:rgba(64,134,252,1);
            border-radius:0.46rem;
            font-size: .32rem;
            color: white;
            line-height: 0.88rem;
            text-align: center;
            margin-top: 0.9rem;
        }
    }

    .bottom-logo{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.33rem 0;
        width: 100%;
        img{
            width: 0.64rem;
            height: 0.64rem;
            margin-right: 0.21rem;
        }
        div{
            font-size: 0.28rem;
            color:  rgba(225, 225, 225, 0.6);
        }
    }
}


</style>